'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "valueFormatter", "hovered"],
  _excluded2 = ["hovered"];
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component, PureComponent } from 'react';
import partial from 'react-utils/partial';
import memoizeOne from 'react-utils/memoizeOne';
import SyntheticEvent from '../../core/SyntheticEvent';
import HoverProvider from '../../providers/HoverProvider';
import UITypeaheadResults from '../../typeahead/results/UITypeaheadResults';
import UITypeaheadResultsItem from '../../typeahead/results/UITypeaheadResultsItem';
import range from '../../utils/underscore/range';
import { jsx as _jsx } from "react/jsx-runtime";
export function parseValue(format, rawValue) {
  if (rawValue == null || rawValue === '') {
    return undefined;
  }
  const moment = I18n.moment.utc(rawValue, format);
  return moment.hours() * 60 + moment.minutes();
}
export function formatValue(format, value) {
  if (value == null) {
    return '';
  }
  return I18n.moment.utc(0).minutes(value).format(format);
}
const getOptionForValue = (value, valueFormatter) => ({
  text: valueFormatter ? valueFormatter(value) : value,
  value
});
export const PrivateTimePickerOption = class PrivateTimePickerOption extends Component {
  constructor(props) {
    super(props);
    this.scrollIntoView = () => {
      const el = this._ref;
      if (el == null) {
        return;
      }
      const {
        offsetHeight,
        offsetParent,
        offsetTop
      } = el;
      offsetParent.scrollTop = offsetTop - (offsetParent.offsetHeight - offsetHeight) / 2;
    };
    this.refCallback = ref => {
      this._ref = ref;
    };
    this._getOption = memoizeOne(getOptionForValue);
  }
  componentDidMount() {
    if (this.props.highlighted) {
      this.scrollIntoView();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      highlighted
    } = this.props;
    if (!this._hovered && highlighted && !prevProps.highlighted) {
      this.scrollIntoView();
    }
  }
  render() {
    const _this$props = this.props,
      {
        value,
        valueFormatter
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const option = this._getOption(value, valueFormatter);
    return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, this.props, {
      children: hoverProviderProps => {
        const {
            hovered
          } = hoverProviderProps,
          hoverProviderRestProps = _objectWithoutPropertiesLoose(hoverProviderProps, _excluded2);
        this._hovered = hovered;
        return /*#__PURE__*/_jsx(UITypeaheadResultsItem, Object.assign({}, rest, hoverProviderRestProps, {
          ref: this.refCallback,
          option: option
        }));
      }
    }));
  }
};
export class PrivateTimePickerOptions extends PureComponent {
  render() {
    const {
      focusedValue,
      valueFormatter,
      interval,
      makeOptionId,
      max,
      min,
      onOptionClick,
      onOptionHover
    } = this.props;

    // Use the closest interval multiple as the min/max in the dropdown (see #7688)
    const computedMin = Math.ceil(min / interval) * interval;
    const computedMax = (Math.floor(max / interval) + 1) * interval;
    return /*#__PURE__*/_jsx(UITypeaheadResults, {
      children: range(computedMin, computedMax, interval).map(value => /*#__PURE__*/_jsx(PrivateTimePickerOption, {
        id: makeOptionId(value),
        valueFormatter: valueFormatter,
        highlighted: value === focusedValue,
        value: value,
        onMouseDown: evt => {
          /* This handler is passed as onMouseDown instead of onClick so that it fires before
          the parent component's input's `blur` event */
          onOptionClick(SyntheticEvent(value, evt));
        },
        onMouseEnter: partial(onOptionHover, value)
      }, value))
    });
  }
}
PrivateTimePickerOptions.propTypes = {
  focusedValue: PropTypes.number,
  valueFormatter: PropTypes.func,
  interval: PropTypes.number,
  makeOptionId: PropTypes.func,
  max: PropTypes.number,
  min: PropTypes.number,
  onOptionHover: PropTypes.func.isRequired,
  onOptionClick: PropTypes.func
};